export default __webpack_public_path__ + "2ffe4fc92f1491874faeb0fb846c0035.coffee";